module.exports = __webpack_public_path__ + "static/media/ex8-slow.bf8f9171.mp3";